import dayjs from 'dayjs';

// dayjs has no built-in equivalent to moment.parseZone (parse an ISO string while keeping ITS
// embedded UTC offset for display, rather than converting to the browser's local offset).
// dayjs(value) already computes the correct underlying instant from an embedded offset the same
// way moment/native Date do - only the *displayed* offset needs relabeling, via the utc plugin's
// .utcOffset(minutes). Shared by window.DT.dt() (src/javascripts/common.js) and
// components/common/AgGrid/index.jsx's dateFormatter, which both need this exact behavior.
const ISO_OFFSET_REGEX = /(?:Z|([+-]\d{2}):?(\d{2}))$/;

export function parseZone(value) {
  const match = ISO_OFFSET_REGEX.exec(value);
  const d = dayjs(value);
  if (!match) return d;
  if (match[0] === 'Z') return d.utcOffset(0);
  const sign = match[1].startsWith('-') ? -1 : 1;
  return d.utcOffset(sign * (Math.abs(parseInt(match[1], 10)) * 60 + parseInt(match[2], 10)));
}
